import { css } from '@linaria/atomic';

// Colocated here (rather than inline in draggable-block.tsx) so that file does
// not import @linaria/*. draggable-block.tsx exports a self-referential `Point`
// class that trips the wyw-in-js shaker ("Duplicate declaration"); keeping the
// linaria import out of it lets wyw fast-skip the module.
export const dragIconStyle = css`
  pointer-events: none;
  display: block;
`;
